import { useEmitter } from '@/composables/emitter'
import { EVENTS } from '@/lib/consts'

/*
 * trigger from JS console:
 * document.dispatchEvent(new CustomEvent('BooksyWebViewMessage', { detail: { name: "resume", data: {} }}))
 */

const name = 'resume'

const callback = () => {
  const emitter = useEmitter()
  emitter.emit(EVENTS.WEB_VIEW_RESUME)
}

export default { name, callback }
